import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { CrownRoundedIcon } from '../../../components/SVGIcons/CrownRoundedIcon';
import { analytics } from '../../../services/analytics';
import { useFlag } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import { translateTierName } from '../../../utils/tierTranslation';

import BonusCards from './BonusCards';
import BonusFooter from './BonusFooter';
import BonusProgress from './BonusProgress';
import classes from './DailyBonus.module.scss';

export default function DailyBonus() {
  const { loyaltyProgramStore } = useStores();
  const loyaltyProgramFlag = useFlag('loyalty_program', true);
  const { t } = useTranslation();

  useEffect(() => {
    void analytics.sendEvent('daily_bonus' as any, {
      event_action: 'impression',
    });
  }, []);

  const { currentTier } = loyaltyProgramStore.userLoyalty ?? {};

  const isInTierHigherThanEntry = currentTier && currentTier.level > 1;
  const tierColor = isInTierHigherThanEntry ? currentTier.color : undefined;
  const tierName = currentTier?.name ? translateTierName(currentTier.name) : '';
  const crownColor = loyaltyProgramFlag ? tierColor : undefined;

  const renderTitle = (text: string) => {
    const crownIndex = text.toLowerCase().indexOf('o');
    if (crownIndex === -1) {
      return text;
    }
    return (
      <>
        {text.slice(0, crownIndex)}
        <div className={classes.crown}>
          {text[crownIndex]}
          <CrownRoundedIcon color={crownColor} />
        </div>
        {text.slice(crownIndex + 1)}
      </>
    );
  };

  return (
    <div className={classes.dailyBonus}>
      <div className={'animation-popup ' + classes.title}>
        {loyaltyProgramFlag && isInTierHigherThanEntry ? <span style={{ color: tierColor }}>{tierName} </span> : null}
        <div className={classes.bonusWord}>{renderTitle(t('rewards.dailyBonus'))}</div>
      </div>
      <BonusProgress />
      <BonusCards />
      <BonusFooter />
    </div>
  );
}
